import React from "react";

// ui
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";
import RequiredIndicator from "../Form/RequiredIndicator";

const DropDown = (props) => {
	const {
		name,
		label,
		placeholder,
		touched,
		error,
		required,
		onChange,
		onBlur,
		options,
		nullable,
		value,
	} = props;
	const inputId = `input-${name}`;

	const valid = required & touched && !error ? true : false;
	const invalid = required & touched && error ? true : false;
	const requiredIndicator = nullable ? false : true;

	return (
		<FormGroup>
			<Label for={inputId}>
				{label} {requiredIndicator && required && <RequiredIndicator />}
			</Label>
			<Input
				type="select"
				name={name}
				id={inputId}
				placeholder={placeholder}
				onChange={onChange}
				onBlur={onBlur}
				invalid={invalid}
				valid={valid}
				value={value}
				style={{ backgroundImage: "none" }}
			>
				{options.map((option) => (
					<option key={`key-${option.value}`} value={option.value}>
						{option.label}
					</option>
				))}
			</Input>
			{required && invalid && (
				<FormFeedback valid={valid}>{error}</FormFeedback>
			)}
		</FormGroup>
	);
};

DropDown.defaultProps = {
	placeholder: "",
	touched: false,
	error: false,
	required: false,
};

export default DropDown;
